module.exports = __webpack_public_path__ + "img/app-logo1@2x.f651f874.png";